<template>
  <div class="hello">
	<div class="absol" style="width: 70px;">
		<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="10">
			<img class="side" src="../../public/index/微信.png" />
			<div v-show="activeIndex=='10'" style="position: absolute;z-index: 999;top: 0px;right: 70px;">
				<img v-show="this.$i18n.locale == 'zh'" style="width: 200px;" src="../../public/index/erweima.png" />
				<img v-show="this.$i18n.locale == 'en'" style="width: 200px;" src="../../public/index/erweima1.png" />
			</div>
		</div>
		
		<div>
			<a v-show="this.$i18n.locale == 'zh'" target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=2571177189&site=qq&menu=yes">
				<img border="0" class="side" src="../../public/index/qq.png" alt="点击这里给我发消息" title="点击这里给我发消息" />
			</a>
			<div v-show="this.$i18n.locale == 'en'" @mouseover="mouseOver" @mouseleave="mouseLeave" id="12">
				<img  border="0" class="side" src="../../public/index/email.png" />
				<div v-show="activeIndex=='12'" style="position: absolute;z-index: 999;top: 81px;right: 70px;">
					<img style="width: 200px;" src="../../public/index/emailmsg.png" />
				</div>
			</div>
		</div>
		
		<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="11">
			<img class="side" src="../../public/index/phone1.png" />
			<div v-show="activeIndex=='11'" style="position: absolute;z-index: 999;top: 81px;right: 70px;">
				<img v-show="this.$i18n.locale == 'zh'" style="width: 200px;" src="../../public/index/tel.png" />
				<img v-show="this.$i18n.locale == 'en'" style="width: 200px;" src="../../public/index/tel1.png" />
			</div>
		</div>
		

		<router-link to="regist" target="_blank">
			<div>
				<img class="side" src="../../public/index/commit.png" />
			</div>
		</router-link>

	</div>
	
	
    <div style="height: 100%;">
		<div style="height: 70px; background-color: #121210;top: 0px;position:fixed;width: 100%;z-index: 9999;">
			<div class="center" style="height: 100%; color: white;">
				<el-row ::gutter='0' class="center" style="">
					<el-col :span="2">
						<router-link to="/" target="_blank">
							<img src="../../public/helloworld/LGOO.png" style="height: 100%;width: 90px;"/>
						</router-link>
					</el-col>
					<el-col :span="2">
						<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="1" @click="close">
							<p style="height: 100%;text-align: center;line-height: 100%;margin: 0;padding: 0;width: 150px;">
								{{ $t('lang.Best_sellers')}}
							</p>
							<div v-show="activeIndex=='1'" style="position: absolute;z-index: 9998;width: 1700px;color: white;left:-50px;" class="center">
								<div style="background-color: #121210;">
									<ul class="ultransverse" style="float: left;">
										<li class="litransverse" style="margin: 40px;">
											<router-link to="Sterilization-robot" target="_blank">
												<img src="../../public/helloworld/0e.png" style="width: 150px;"/>
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.Spray_disinfection')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										<li class="litransverse" style="margin: 40px;">
											<router-link to="UVC-robot" target="_blank">
												<img src="../../public/helloworld/0D.png" style="width: 150px;"/>
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.UVC_disinfection')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										
										<li class="litransverse" style="margin: 40px;">
											<router-link to="Sterilizer" target="_blank">
												<img src="../../public/pic/idp/idp.jpg" style="width: 150px;" />
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.homedis24')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										<!--
										<li class="litransverse" style="margin: 40px;">
											<router-link to="Food-delivery-robot" target="_blank">
												<img src="../../public/helloworld/0C.png" style="width: 150px;"/>
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.Delivery')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										-->
										<li class="litransverse" style="margin: 40px;">
											<router-link to="Receptionist-robot" target="_blank">
												<img src="../../public/helloworld/0A.png" style="width: 150px;"/>
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.Receptionist')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										<li class="litransverse" style="margin: 40px;">
											<router-link to="Companion-robot" target="_blank">
												<img src="../../public/helloworld/0B.png" style="width: 150px;" />
												<el-divider style="color: white;"></el-divider>
												<p>{{ $t('lang.Companion')}}</p>
												<p>{{ $t('lang.Robot')}}</p>
											</router-link>
										</li>
										
									</ul>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="2">
						<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="2">
							<p style="height: 50px;text-align: center;line-height: 50px;margin: 0;padding: 0;width: 150px;">
								{{ $t('lang.Business')}}
							</p>
							<div v-show="activeIndex=='2'" style=" position: absolute;z-index: 9999;color: white;width: 180px;" class="center">
								<div style="background-color: #4a4a4a;">
									<ul class="ultransverse" style="margin: 0;padding: 0;">
										<li class="litransverse hov">
											<router-link to="buy" target="_blank">
												<p style="margin: 10px;">{{ $t('lang.Buy')}}</p>
											</router-link>
										</li><br />
										<li class="litransverse hov">
											<router-link to="buy" target="_blank">
												<p style="margin: 10px;">{{ $t('lang.Become_an_agent')}}</p>
											</router-link>
										</li><br />
										<li class="litransverse hov">
											<router-link to="cooperate" target="_blank">
												<div style="text-align: center;margin: 0;padding: 0;width: 100px;">
													<p style="margin: 10px;">{{ $t('lang.Our_customers')}}</p>
												</div>
											</router-link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="2">
						<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="4">
							<p style="height: 50px;text-align: center;line-height: 50px;margin: 0;padding: 0;width: 150px;">
								{{ $t('lang.Support')}}
							</p>
							<div v-show="activeIndex=='4'" style="position: absolute;z-index: 9999;color: white;width: 180px;" class="center">
								<div style="background-color: #4a4a4a;">
									<ul class="ultransverse" style="margin: 0;padding: 0;">
										<li class="litransverse hov">
											<router-link to="aftersale" target="_blank">
												<p style="margin: 10px;">{{ $t('lang.After_sale_service')}}</p>
											</router-link>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="2">
						<div @mouseover="mouseOver" @mouseleave="mouseLeave" id="5">
							<p style="height: 50px;text-align: center;line-height: 50px;margin: 0px;padding: 0;width: 150px;">
								{{ $t('lang.About_us')}}
							</p>
							<div v-show="activeIndex=='5'" style="position: absolute;z-index: 9999;color: white;width: 180px;" class="center">
								<div style="background-color: #4a4a4a;">
									<ul class="ultransverse" style="margin: 0;padding: 0;">
										<li class="litransverse hov">
											<router-link to="profile" target="_blank"><p style="margin: 10px;">{{ $t('lang.Company_profile')}}</p></router-link>
										</li><br />
										<li class="litransverse hov">
											<router-link to="dynamic" target="_blank"><p style="margin: 10px;">{{ $t('lang.News')}}</p></router-link>
										</li><br />
										<li class="litransverse hov">
											<router-link to="contact" target="_blank"><p style="margin: 10px;">{{ $t('lang.Contact_us')}}</p></router-link>
										</li><br />
									</ul>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="2">
						<div style="width: 150px;">
							<a href="http://www.aitech-cms.com/" target="_blank" style="width: 150px;color: white;text-decoration:none">
								<p >{{ $t('lang.SDK')}}</p>
								</a>
						</div>
					</el-col>
					<el-col :span="2"><div class="center" style="padding-left: 30px;"><i class=" el-icon-phone" style="font-size: 30px; color: white;width: 150px;">
						</i>{{ $t('lang.tel')}}</div>
					</el-col>
					<el-col :span="2"><div @click="changeLaguages()" style="width: 150px;">{{ $t('lang.language')}}</div></el-col>
					<el-col :span="2">
						<div class="center" style="color: white;width: 150px;">
							<input v-model="tel" :placeholder="$t('lang.Input_phone')" style="width: 120px;margin-right: 10px;height: 20px;">
						</div>
					</el-col>
					<el-col :span="2">
						<div @click="onSubmit()" style="width: 150px;">
							<button class="button">
									{{ $t('lang.For_details')}} 
							</button>
						</div>
					</el-col>
				</el-row>
			</div>
		</div>
		
		
		<div style="padding-top: 50px;padding-left: 0px;padding-bottom: opx;padding-right: 0px;">
			<router-view style="width: 100%;"></router-view>
		</div>
		
		
		<div class="footer center " style="height: 500px;padding-top: 100px;">
			<div style="width: 60%;">
				<el-divider style="color: white;"></el-divider>
				<div style="color: white;">
					<el-row style="font-size: 15px;">
						<el-col :span="5">
							<p>{{ $t('lang.Best_sellers')}}</p>
							<router-link to="/Sterilization-robot" target="_blank">
								<p class="bottomfont">{{ $t('lang.Spray_disinfection')}}</p>
							</router-link>
							<router-link to="/UVC-robot" target="_blank">
								<p class="bottomfont">{{ $t('lang.UVC_disinfection')}}</p>
							</router-link>
							<router-link to="/Receptionist-robot" target="_blank">
								<p class="bottomfont">{{ $t('lang.Receptionist')}}</p>
							</router-link>
							<router-link to="/Companion-robot" target="_blank">
								<p class="bottomfont">{{ $t('lang.Companion')}}</p>
							</router-link>
						</el-col>
						<el-col :span="5">
							<p>{{ $t('lang.Business')}}</p>
							<router-link to="/buy" target="_blank">
								<p class="bottomfont">{{ $t('lang.Buy')}}</p>
							</router-link>
							<router-link to="/buy" target="_blank">
								<p class="bottomfont">{{ $t('lang.Become_an_agent')}}</p>
							</router-link>
							<router-link to="/cooperate" target="_blank">
								<p class="bottomfont">{{ $t('lang.Our_customers')}}</p>
							</router-link>
						</el-col>
						<el-col :span="5">
							<p>{{ $t('lang.Support')}}</p>
							<router-link to="/aftersale" target="_blank">
								<p class="bottomfont">{{ $t('lang.After_sale_service')}}</p>
							</router-link>
						</el-col>
						<el-col :span="5">
							<p>{{ $t('lang.About_us')}}</p>
							<router-link to="/profile" target="_blank">
								<p class="bottomfont">{{ $t('lang.Company_profile')}}</p>
							</router-link>
							<router-link to="/dynamic" target="_blank">
								<p class="bottomfont">{{ $t('lang.News')}}</p>
							</router-link>
							<router-link to="/contact" target="_blank">
								<p class="bottomfont">{{ $t('lang.Contact_us')}}</p>
							</router-link>
						</el-col>
						<el-col :span="4">
							<a href="http://www.aitech-cms.com/" target="_blank">
								<p>{{ $t('lang.SDK')}}</p>
							</a>
						</el-col>
					</el-row>
					<el-row style="font-size: 15px;width: 100%;">
						<el-col :span="8">
							<i class="el-icon-phone-outline"></i>&nbsp;&nbsp;&nbsp;&nbsp;
							<div>{{ $t('lang.buy5')}}</div>
						</el-col>
						<el-col :span="8">
							<i class="el-icon-message"></i>
							<div>{{ $t('lang.buy8')}}</div>
						</el-col>
						<el-col :span="8">
							<i class="el-icon-chat-round"></i>
							<div>entitydoll2017</div>
						</el-col>
					</el-row>
				</div>
				<el-divider style="color: white;"></el-divider>
				<div><a href="https://beian.miit.gov.cn/" target="_blank"><p>ICP备案号：粤ICP备16090641号</p></a></div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
	
	

export default {
	data() {
		return {
			activeIndex: '',
			tel:'',
		};
	},
	methods: {
		handleSelect(key, keyPath) {
			console.log(key, keyPath);
		},
	// 移入
		mouseOver:function(event) {
			//alert(event.currentTarget.id)
			this.activeIndex = event.currentTarget.id
		},
    // 移出
		mouseLeave:function() {
			this.activeIndex = ''
		},
		onSubmit(){
			if(this.tel === ""){
				if(this.$i18n.locale == 'zh'){
					alert("请输入电话号码");
				}else{
					alert("Please enter the phone number");
				}
				
			}else{
				this.axios({
					// 默认请求方式为get
					method: 'get',
					//url: 'http://localhost:8080/mail/send_mail',
					url: 'http://www.aitech-cms.com/mail/send_mail',
					// 传递参数
					params: {
						tel: this.tel,
					},
				}).then(response => {
					// 请求成功
					console.log(JSON.stringify(response));
					let res = response.data.msg;
					console.log(JSON.stringify(res));
				}).catch(error => {
					// 请求失败，当then种出错就进入这里
					console.log("请求失败"+JSON.stringify(error));
				
				});
			}
		},
		close(){
			this.activeIndex = ''
		},
		changeLaguages () {
			console.log(this.$i18n.locale)
			let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
			this.$i18n.locale = lang
		},
		
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

a {
  color: #42b983;
}
.hello{
  height: 100%;
}
p{
	color: white;
}
.absol{
	position:fixed;
	z-index: 9999;
	top: 250px;
	right: 0px;
}
.side{
	width: 70px;
}
.bottomfont{
	color: gray;
	font-size: 16px;
}





.button {
	height: 30px;
	width: 100px;
	display: inline-block;
	font-size: 20px;
	cursor: pointer;
	text-align: center;   
	text-decoration: none;
	outline: none;
	color: #fff;
	background-color: #5500ff;
	border: none;
	border-radius: 15px;
	box-shadow: 0 4px #999;
}

.button:hover {background-color: #00aaff}

.button:active {
	background-color: #00aa00;
	box-shadow: 0 5px #666;
	transform: translateY(2px);
}




.hov:hover{
	background-color: grey;
	width: 100;
}

</style>
